import React from 'react'
import IconButton from '@mui/material/IconButton';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';

import "./contact.css"

function About() {
    return (
        <div className="contact">
            <div className='imageContact1'></div>
            <div className='containerIcons'>
                <span><h2>Contact</h2></span>
                <span>
                    <IconButton aria-label="facebook" >
                        <FacebookRoundedIcon sx={{ fontSize: 60, color: 'white' }} onClick={() => { window.open('https://www.facebook.com/cominboard/')}} />
                    </IconButton>
                </span>
                <span>
                    <IconButton aria-label="mail" sx={{ color: 'white' }} >
                        <MailOutlineRoundedIcon sx={{ fontSize: 60, color: 'white' }} onClick={() => { window.open('mailto:bbeckers@cominboard.fr')}}/>
                    </IconButton>
                </span>
                <span>
                    <p className='name'>
                        Bénédicte Beckers <br/>
                        <a href="tel:+33782730609" className='Tel'>+33 7 82 76 06 09</a>
                    </p>
                    
                </span>
            </div>
            <div className='imageContact2'></div>
        </div>
    )
}

export default About